module.exports = __webpack_public_path__ + "img/icons BFr_18.fbf6b8e0.svg";